module.exports = __webpack_public_path__ + "img/Storage=Auto-On.ff0f2198.svg";